import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { assetApi, type QualityReport } from '../../api/media';

export function QualityDashboardPage() {
  const { id = '' } = useParams();
  const [quality, setQuality] = useState<QualityReport | null>(null);

  useEffect(() => {
    if (!id) return;
    void assetApi.quality(id).then(setQuality);
  }, [id]);

  return (
    <div className="mx-auto max-w-3xl p-6">
      <Link to={id ? `/media/assets/${id}` : '/media'} className="text-sm text-slate-600 hover:underline">← Back</Link>
      <h1 className="mt-4 text-2xl font-semibold">Quality Dashboard</h1>
      {quality ? (
        <div className="mt-6 space-y-4">
          <div className="rounded-xl border bg-white p-6">
            <p className="text-sm text-slate-500">Overall score</p>
            <p className="text-3xl font-semibold">{quality.score}</p>
            <p className="capitalize text-slate-600">{quality.status}</p>
          </div>
          {quality.checks && (
            <ul className="grid gap-2 sm:grid-cols-2 text-sm">
              {Object.entries(quality.checks).map(([k, v]) => (
                <li key={k} className={`rounded border px-3 py-2 ${v ? 'border-green-200 bg-green-50' : 'border-amber-200 bg-amber-50'}`}>
                  {k.replace(/_/g, ' ')}: {v ? 'pass' : 'fail'}
                </li>
              ))}
            </ul>
          )}
          {quality.issues?.length ? (
            <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm">
              <p className="font-medium">Issues</p>
              <ul className="mt-2 list-disc pl-5">{quality.issues.map((i) => <li key={i}>{i}</li>)}</ul>
            </div>
          ) : null}
        </div>
      ) : (
        <p className="mt-6 text-slate-500">Loading quality data…</p>
      )}
    </div>
  );
}
